(function () {
  // Durée à synchroniser avec --pt-duration
  const DURATION = 320;

  // Ne pas gêner l’éditeur de thème
  if (window.Shopify && Shopify.designMode) return;

  const html = document.documentElement;

  // Entrée : quand la page arrive (y compris via Back/Forward cache)
  function animateIn() {
    html.classList.remove('page-leave');
    html.classList.add('page-enter');
    // Retire la classe une fois l'anim terminée
    setTimeout(() => html.classList.remove('page-enter'), DURATION + 20);
  }

  // Sortie : avant de partir
  function animateOutAndGo(href) {
    html.classList.add('page-leave');
    setTimeout(() => { window.location.assign(href); }, DURATION);
  }

  // Doit-on ignorer ce lien ?
  function shouldIgnoreLink(a) {
    if (!a) return true;
    const url = new URL(a.href, window.location.origin);

    // Externes, ancres, fichiers, nouveaux onglets, tel/mail, no-transition, checkout/cart
    if (a.target && a.target !== '' && a.target !== '_self') return true;
    if (a.hasAttribute('download')) return true;
    if (a.hasAttribute('data-no-transition')) return true;
    if (a.href.startsWith('mailto:') || a.href.startsWith('tel:')) return true;
    if (url.origin !== window.location.origin) return true;
    if (url.pathname === window.location.pathname && url.hash) return true;
    if (/\/(cart|checkout)(\/|$)/.test(url.pathname)) return true; // laissez ces pages tranquilles

    return false;
  }

  // Délégation de clics
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || shouldIgnoreLink(a)) return;
    e.preventDefault();
    animateOutAndGo(a.href);
  });

  // Entrée à chaque affichage
  window.addEventListener('pageshow', animateIn);
  document.addEventListener('DOMContentLoaded', animateIn);
})();
